// src/components/PageLoader.jsx

import { BrandLoader } from './BrandLoader'; // 1. Importe o novo BrandLoader

export function PageLoader() {
  return (
    // Overlay de tela cheia
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm">
      
      {/* 2. Use o BrandLoader no centro */}
      <BrandLoader size={100} /> 
      
      <p className="mt-4 text-sm font-medium text-gray-600 dark:text-gray-400">
        Carregando...
      </p>
    </div>
  );
}
